import React from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import User from "../../api/User";
import Media from "../../api/Media";
import RolesState from "../../api/RolesState";
import Msg from "../../api/Msg";

export const ItemUserAdminPanel = observer(
  ({
    user,
    actionSuperUser,
    actionActiveUser,
    showSuperuserCol,
    showArchive,
    gridClass,
  }) => {
    const roleLabel =
      user.role_rel !== null
        ? user.role_rel.role_name
        : "Роль не назначена";

    const onActiveClick =
      User.user.is_superuser
        ? () => actionActiveUser(user)
        : () =>
            Msg.writeMessages(
              "У вас нет прав для изменения активности сотрудника",
            );

    const rowClass = [
      "cc-v4-soft-row",
      gridClass,
      !user.is_active && showArchive ? "admin-users-row--archived" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={rowClass}>
        <Link
          to={`/employees/${user.id}`}
          className="admin-users-link-contents"
        >
          <span className="admin-users-cell company-card-v4-mono">
            {user.last_name}
          </span>
          {!Media.mobile ? (
            <span className="admin-users-cell">{user.first_name}</span>
          ) : (
            <span className="admin-users-cell admin-users-cell--empty" />
          )}
          {!Media.mobile ? (
            <span className="admin-users-cell company-card-v4-mono">
              {user.email}
            </span>
          ) : (
            <span className="admin-users-cell admin-users-cell--empty" />
          )}
          <span
            className={`admin-users-cell${
              user.role_rel === null ? " admin-users-cell--muted" : ""
            }`}
          >
            {roleLabel}
          </span>
        </Link>

        {User.user.is_superuser || RolesState.admin_panel ? (
          <div className="admin-users-toggle-cell">
            <CcV4Toggle onClick={onActiveClick} active={user.is_active} />
          </div>
        ) : (
          <span className="admin-users-cell--empty" />
        )}

        {showSuperuserCol ? (
          <div className="admin-users-toggle-cell">
            <CcV4Toggle
              onClick={() => actionSuperUser(user)}
              active={user.is_superuser}
            />
          </div>
        ) : null}
      </div>
    );
  },
);
